// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"8577203f45cdb0499311","966":"7ecc2d52e8f222ff95a4"}[chunkId] + ".js";
};